import { Component } from '@angular/core';

@Component({
    selector: 'app-monitoring-dashboard',
    templateUrl: './monitoring-dashboard.component.html',
    styleUrl: './monitoring-dashboard.component.css',
    standalone: false
})
export class MonitoringDashboardComponent {

}
